/**
 * Advertorials · Doctor Branson
 * - Reenvía los parámetros de campaña (utm_*, fbclid, etc.) a todos los botones de compra.
 * - Publica un evento "adv_cta_click" en los píxeles de Shopify (Customer events) al pulsar un botón.
 * - Controla la barra fija inferior y la barra superior que se oculta al bajar.
 */
(function () {
  'use strict';

  var FORWARD_PARAMS = /^(utm_[a-z_]+|fbclid|gclid|ttclid|campaign_id|adset_id|ad_id|ref)$/i;

  function collectParams() {
    var out = [];
    try {
      var params = new URLSearchParams(window.location.search);
      params.forEach(function (value, key) {
        if (FORWARD_PARAMS.test(key)) out.push([key, value]);
      });
    } catch (e) {}
    return out;
  }

  function decorateLinks(root) {
    var params = collectParams();
    if (!params.length) return;
    var links = (root || document).querySelectorAll('a[data-adv-cta]');
    links.forEach(function (link) {
      if (link.dataset.advDecorated) return;
      var href = link.getAttribute('href');
      if (!href || href.charAt(0) === '#' || /^(mailto|tel|javascript):/i.test(href)) return;
      try {
        var url = new URL(href, window.location.origin);
        if (url.origin !== window.location.origin) return;
        params.forEach(function (pair) {
          if (!url.searchParams.has(pair[0])) url.searchParams.set(pair[0], pair[1]);
        });
        link.setAttribute('href', url.pathname + url.search + url.hash);
        link.dataset.advDecorated = '1';
      } catch (e) {}
    });
  }

  /**
   * Botones configurados como "Destino general de la página": toman el enlace que se define
   * una sola vez en la sección "Adv · Estilo general" (producto, checkout directo o URL).
   */
  function applyDefaultDestination(root) {
    var source = document.querySelector('[data-adv-default-href]');
    if (!source) return;
    var href = source.getAttribute('data-adv-default-href');
    var dest = source.getAttribute('data-adv-default-dest') || '';
    if (!href || href === '#') return;
    (root || document).querySelectorAll('a[data-adv-use-default]').forEach(function (link) {
      link.setAttribute('href', href);
      link.dataset.advDest = dest;
      delete link.dataset.advDecorated;
    });
  }


  /**
   * Cuentas atrás con fecha de fin real (zona horaria de la tienda).
   * Al llegar a cero se ocultan; no se reinician.
   */
  function countdowns(root) {
    (root || document).querySelectorAll('[data-adv-countdown]').forEach(function (el) {
      if (el._advTimer) clearInterval(el._advTimer);
      var raw = el.getAttribute('data-end') || '';
      var tz = el.getAttribute('data-tz') || '+0000';
      var m = /^(\d{4}-\d{2}-\d{2})T(\d{1,2}):(\d{2})$/.exec(raw.trim());
      if (!m) { el.hidden = true; return; }
      var tzc = /^[+-]\d{4}$/.test(tz) ? tz.slice(0, 3) + ':' + tz.slice(3) : 'Z';
      var hh = ('0' + m[2]).slice(-2);
      var end = Date.parse(m[1] + 'T' + hh + ':' + m[3] + ':00' + tzc);
      if (isNaN(end)) { el.hidden = true; return; }
      var d = el.querySelector('[data-cd-d]');
      var dWraps = el.querySelectorAll('[data-cd-d-wrap]');
      var h = el.querySelector('[data-cd-h]');
      var mi = el.querySelector('[data-cd-m]');
      var se = el.querySelector('[data-cd-s]');
      var bar = el.closest('[data-adv-cdbar]');
      function pad(n) { return (n < 10 ? '0' : '') + n; }
      function tick() {
        var diff = Math.floor((end - Date.now()) / 1000);
        if (diff <= 0) {
          clearInterval(el._advTimer);
          el.hidden = true;
          if (bar && bar.getAttribute('data-hide-expired') === 'true') bar.hidden = true;
          return;
        }
        el.hidden = false;
        var showDays = diff >= 48 * 3600 && d;
        Array.prototype.forEach.call(dWraps, function (w) { w.hidden = !showDays; });
        if (showDays) {
          d.textContent = Math.floor(diff / 86400);
          if (h) h.textContent = pad(Math.floor((diff % 86400) / 3600));
        } else if (h) {
          h.textContent = pad(Math.floor(diff / 3600));
        }
        if (mi) mi.textContent = pad(Math.floor((diff % 3600) / 60));
        if (se) se.textContent = pad(diff % 60);
      }
      tick();
      el._advTimer = setInterval(tick, 1000);
    });
  }

  function trackClicks() {
    document.addEventListener('click', function (event) {
      var link = event.target.closest && event.target.closest('a[data-adv-cta]');
      if (!link) return;
      var detail = {
        position: link.dataset.advCta || '',
        destination: link.dataset.advDest || '',
        href: link.getAttribute('href') || '',
        page: window.location.pathname
      };
      try {
        if (window.Shopify && window.Shopify.analytics && typeof window.Shopify.analytics.publish === 'function') {
          window.Shopify.analytics.publish('adv_cta_click', detail);
        }
      } catch (e) {}
      try {
        window.dataLayer = window.dataLayer || [];
        window.dataLayer.push({ event: 'adv_cta_click', adv: detail });
      } catch (e) {}
    });
  }

  function stickyBars() {
    var sticky = document.querySelector('[data-adv-sticky-cta]');
    var topbar = document.querySelector('[data-adv-topbar][data-hide-on-scroll="true"]');
    if (!sticky && !topbar) return;

    var showAfter = sticky ? parseInt(sticky.dataset.showAfter || '600', 10) : 0;
    var offers = Array.prototype.slice.call(document.querySelectorAll('[data-adv-offer], [data-adv-buyform]'));
    var offerVisible = false;

    if (sticky && offers.length && 'IntersectionObserver' in window) {
      var visibleSet = new Set();
      var io = new IntersectionObserver(function (entries) {
        entries.forEach(function (entry) {
          if (entry.isIntersecting) visibleSet.add(entry.target);
          else visibleSet.delete(entry.target);
        });
        offerVisible = visibleSet.size > 0;
        update();
      }, { threshold: 0 });
      offers.forEach(function (el) { io.observe(el); });
    }

    var lastY = window.scrollY;
    var ticking = false;

    function update() {
      var y = window.scrollY;
      if (sticky) {
        var nearBottom = window.innerHeight + y >= document.documentElement.scrollHeight - 40;
        var show = y > showAfter && !offerVisible && !nearBottom;
        sticky.classList.toggle('is-visible', show);
      }
      if (topbar) {
        var goingDown = y > lastY && y > 120;
        topbar.classList.toggle('is-hidden', goingDown);
      }
      lastY = y;
      ticking = false;
    }

    window.addEventListener('scroll', function () {
      if (!ticking) {
        ticking = true;
        window.requestAnimationFrame(update);
      }
    }, { passive: true });

    update();
  }

  function init() {
    countdowns(document);
    applyDefaultDestination(document);
    decorateLinks(document);
    stickyBars();
  }

  trackClicks();

  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', init);
  } else {
    init();
  }

  // Reaplicar dentro del personalizador cuando se recarga una sección.
  document.addEventListener('shopify:section:load', function (event) {
    countdowns(event.target);
    applyDefaultDestination(document);
    decorateLinks(document);
  });
})();
